import React from 'react';
import { useIntl } from 'react-intl';
import { useHistory } from 'react-router-dom';

import styles from './headermenu.module.scss';

const { listHeader, subMenu } = styles;

interface IPublicMenuProps {
    onNavigation?: () => void;
}

export const PublicMenu = ({ onNavigation }: IPublicMenuProps): JSX.Element => {
    const { formatMessage } = useIntl();
    const history = useHistory();

    const navigateInPage = (address: string): void => {
        onNavigation?.();
        history.push(address);
    };

    return (
        <nav className={subMenu}>
            <ul>
                <li className={listHeader}>
                    <button
                        data-cy="header-menu-settings"
                        onClick={(): void => {
                            navigateInPage('/settings/profile');
                        }}
                    >
                        {formatMessage({ id: 'SETTINGS' })}
                    </button>
                </li>
                <li>
                    <button
                        data-cy="header-menu-profile"
                        onClick={(): void => {
                            navigateInPage('/settings/profile');
                        }}
                    >
                        {formatMessage({ id: 'TEXT_SETTINGS_PROFILE' })}
                    </button>
                </li>
                <li>
                    <button
                        data-cy="header-menu-access"
                        onClick={(): void => {
                            navigateInPage('/settings/access');
                        }}
                    >
                        {formatMessage({ id: 'MY_ACCESS' })}
                    </button>
                </li>
            </ul>
        </nav>
    );
};
